import type { ReduxState } from '../types/internal/ReduxState';

export default ({ dictateState }: ReduxState) => dictateState;
